const prod_api_url = 'https://api.baai.co/baai/' //production url
const stag_api_url = 'https://con.baai.co/baai/'
const prod_focii_url = 'https://fociiapi.brainalive.ai'

const dev_focii = 'https://devfociiapi.brainalive.ai'
const fociiPlugin = 'https://fociipluginapi.brainalive.ai'
const dev_focii_plugin = 'https://qa.brainalive.ai/development'

// export const api_url = 'https://testapi.brainalive.ai/baai/'
export const api_url = process.env.REACT_APP_ENV === 'production' ? prod_api_url : stag_api_url
// export const api_url = 'http://192.168.29.253:4000/baai/'
// export const api_url = 'http://192.168.29.133:4000/baai/'
// export const api_url = 'http://localhost:4000/baai/'
export const captcha_Key_v3 = '6LfyS7YnAAAAANEF2oKgYbj7jhEJWjake6yRDFtp'
export const walletConnectProjectId = 'daacfec56b90ade889e8b88daacb1858'
export const blog_api_url = 'https://blog.brainalive.ai/'
export const feedback_key = 'b92d8386-cda3-4906-ae4c-e9e244d7531d'
export const focii_url = process.env.REACT_APP_ENV === 'production' ? prod_focii_url : dev_focii
export const plugin_url = process.env.REACT_APP_ENV === 'production' ? fociiPlugin : dev_focii_plugin